import { Box } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";

const FrequencyDataGrid = (props) => {
    const csv = props.csv;
    const { readString } = usePapaParse();
    const [data, setData] = useState([]);

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData((prevState) => {
                    results.data.map((d, idx) => { d.id = idx });
                    return results.data;
                });
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    const cols = [
        { field: 'Report name', headerName: 'Pesticide', flex: 1, minWidth: 100 },
        { field: 'Total number of results_sum', type: 'number', headerName: 'Total results', flex: 1, minWidth: 100 },
        { field: 'Above legal limit result_sum', headerName: 'Above legal limit', flex: 1, minWidth: 100, renderCell: (params) => { return `${params.value} (${params.row['Proportion']})` } },
    ]

    return (
        <Box sx={{ height: 350, marginBottom: '4rem' }}>
            <p style={{ marginBottom: '.5rem' }}>{props.title}</p>
            <DataGrid columns={cols} rows={data} components={{
                Toolbar: GridToolbar,
            }} />
        </Box>
    );
}

export default FrequencyDataGrid;